import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.webp';

interface FooterProps {
  isAboutPage?: boolean;
}

export function Footer({ isAboutPage = false }: FooterProps) {
  if (isAboutPage) {
    return (
      <footer className="site-footer about-footer">
        <div className="footer-bottom">
          <div className="footer-left">
            <img src={logo} alt="Sevnis Small" className="footer-logo" />
            <p>© 2026 SEVNIS. All rights reserved.</p>
          </div>
          <div className="footer-links">
            <NavLink to="#privacy" className="disabled-link">Privacy Policy</NavLink>
            <NavLink to="#terms" className="disabled-link">Terms of Service</NavLink>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="site-footer">
      <p>© 2026 Sevnis. All rights reserved.</p>
    </footer>
  );
}
